import { strLang } from "../functions/strLang";

export const checkDate = (theDate, names = "monthsName") => {
  if (!Array.isArray(theDate)) {
    theDate = theDate.split(" ")[0].split("-");
  }

  switch (localStorage.getItem("lang")) {
    case "esp":
    case "ing":
      theDate.reverse();
      return [
        theDate[0] ? Number(theDate[0]) : null,
        strLang(names)[Number(theDate[1]) - 1],
        theDate[2],
      ].join(" ");

    case "ch":
    case "chs":
      return [
        theDate[0] + "年",
        Number(theDate[1]) + "月",
        theDate[2] ? Number(theDate[2]) + "日" : null,
      ].join("");
    default:
      return theDate.reverse().join("/");
  }
};
